import { ClickableEventNames } from 'contexts/analytics/types';

import { RecommendedCardProps } from '../components/RecommendedCard';

export type UpsellCardKind =
  | 'upsellTinyPlus'
  | 'consult'
  | 'consultAlt'
  | 'facebook';

export const getRecommendedForYouCards = (
  recommendedForYouCards: {
    [key: string]: RecommendedCardProps<ClickableEventNames>;
  },
  getActiveStep: () => number,
  resolvedUpsellCard: UpsellCardKind | null,
  hideUpsells: boolean,
) => {
  const cards = [];

  const activeStep = getActiveStep();

  switch (activeStep) {
    case 0:
    case 1:
      if (!hideUpsells) cards.push(recommendedForYouCards.refer);
      cards.push(recommendedForYouCards.resources);
      cards.push(recommendedForYouCards.facebook);
      break;
    case 2:
    case 3:
    case 4:
    case -1: // All steps completed or last step hidden
      cards.push(recommendedForYouCards.actions);
      if (resolvedUpsellCard === 'upsellTinyPlus') {
        cards.push(recommendedForYouCards.upsellTinyPlus);
      } else if (resolvedUpsellCard === 'consult') {
        cards.push(recommendedForYouCards.consult);
      } else if (resolvedUpsellCard === 'consultAlt') {
        cards.push(recommendedForYouCards.consultAlt);
      } else if (resolvedUpsellCard === 'facebook') {
        cards.push(recommendedForYouCards.facebook);
      }
      !hideUpsells && cards.push(recommendedForYouCards.order);
      cards.push(recommendedForYouCards.resources);
      break;
    default:
      break;
  }

  return cards;
};
